var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error"},[_c('button',{staticClass:"btn",on:{"click":_vm.click}},[_vm._v("去登录")])])}
var staticRenderFns = []

export { render, staticRenderFns }